import { t, useStoreLanguage, getDirection } from "../../features/store-language/i18n.ts";
import { useNavigate } from "react-router-dom";
import "./NotFoundPage.css";

const NotFoundPage = () => {
  useStoreLanguage();
  const navigate = useNavigate();
  const backgroundImageUrl = `${process.env.PUBLIC_URL}/assets/images/notfound.png`;

  return (
    <section
      className="not-found-page"
      dir={getDirection()}
      aria-labelledby="not-found-title"
      style={{
        backgroundImage: `linear-gradient(rgba(13, 18, 38, 0.4), rgba(13, 18, 38, 0.45)), url("${backgroundImageUrl}")`,
      }}
    >
      <div className="not-found-page__card">
        <h1 id="not-found-title" className="not-found-page__title mb-10">
          <span className="not-found-page__brand" aria-hidden="true">{t("رَج")} </span>{" "}{t("مورد نظر وجود ندارد.")} </h1>
        <p className="not-found-page__subtitle">{t("لطفا مسیر را بررسی کنید یا به صفحه قبلی بازگردید.")} </p>

        <button
          type="button"
          className="not-found-page__back-button"
          onClick={() => navigate(-1)}
        >{t("بازگشت به صفحه قبلی")} </button>
      </div>
    </section>
  );
};

export default NotFoundPage;
